import { render } from "./OneAdminAlert.vue?vue&type=template&id=38561344"
import script from "./OneAdminAlert.vue?vue&type=script&lang=js"
export * from "./OneAdminAlert.vue?vue&type=script&lang=js"

import "./OneAdminAlert.vue?vue&type=style&index=0&id=38561344&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__